export const US_STATES = [
    { label: "Alabama", value: "AL" },
    { label: "Alaska", value: "AK" },
    { label: "Arizona", value: "AZ" },
    { label: "Arkansas", value: "AR" },
    { label: "California", value: "CA" },
    { label: "Colorado", value: "CO" },
    { label: "Connecticut", value: "CT" },
    { label: "Delaware", value: "DE" },
    { label: "District of Columbia", value: "DC" },
    { label: "Florida", value: "FL" },
    { label: "Georgia", value: "GA" },
    { label: "Hawaii", value: "HI" },
    { label: "Idaho", value: "ID" },
    { label: "Illinois", value: "IL" },
    { label: "Indiana", value: "IN" },
    { label: "Iowa", value: "IA" },
    { label: "Kansas", value: "KS" },
    { label: "Kentucky", value: "KY" },
    { label: "Louisiana", value: "LA" },
    { label: "Maine", value: "ME" },
    { label: "Maryland", value: "MD" },
    { label: "Massachusetts", value: "MA" },
    { label: "Michigan", value: "MI" },
    { label: "Minnesota", value: "MN" },
    { label: "Mississippi", value: "MS" },
    { label: "Missouri", value: "MO" },
    { label: "Montana", value: "MT" },
    { label: "Nebraska", value: "NE" },
    { label: "Nevada", value: "NV" },
    { label: "New Hampshire", value: "NH" },
    { label: "New Jersey", value: "NJ" },
    { label: "New Mexico", value: "NM" },
    { label: "New York", value: "NY" },
    { label: "North Carolina", value: "NC" },
    { label: "North Dakota", value: "ND" },
    { label: "Ohio", value: "OH" },
    { label: "Oklahoma", value: "OK" },
    { label: "Oregon", value: "OR" },
    { label: "Pennsylvania", value: "PA" },
    { label: "Rhode Island", value: "RI" },
    { label: "South Carolina", value: "SC" },
    { label: "South Dakota", value: "SD" },
    { label: "Tennessee", value: "TN" },
    { label: "Texas", value: "TX" },
    { label: "Utah", value: "UT" },
    { label: "Vermont", value: "VT" },
    { label: "Virginia", value: "VA" },
    { label: "Washington", value: "WA" },
    { label: "West Virginia", value: "WV" },
    { label: "Wisconsin", value: "WI" },
    { label: "Wyoming", value: "WY" }
  ];
  
export const STATE_NAME_TO_ABBR = US_STATES.reduce((acc, { label, value }) => {
    acc[label] = value;
    return acc;
}, {});
  
export const employment_type = [
    { label: "Full Time", value: "full-time" },
    { label: "Part Time", value: "part-time" },
    { label: "Self Employed", value: "self-employed" },
    { label: "Unemployed", value: "un-employed" },
    { label: "Retired", value: "retired" },
  ];
  

  export const married_status = [
    { label: "Married", value: "Married" },
    { label: "Unmarried", value: "Unmarried" },
    { label: "Separated", value: "Separated" },
  ];
  
  export const license_type = [
    { label: "Driver's license", value: "Driving license" },
    { label: "Temporary Driver's License", value: "Temporary Driving License" },
    { label: "CDL", value: "CDL" },
    { label: "Temporary CDL", value: "Temporary CDL" },
    { label: "No Driver's License", value: "No Driving License" },
  ];
  

export const house_type = [
    {label: "Rent" , value:"Rent"},
    {label: "Own Outright", value: "Own Outright"},
    {label: "Buying Mortgage", value: "Buying/Mortgage"},
    {label: "Living with Parents", value: "Living with parents"},
    {label: "Other", value: "Others"},
]

export const cob_house_type = [
  {label: "Rent" , value:"rent"},
  {label: "Own Outright", value: "own"},
  {label: "Buying Mortgage", value: "buying"},
  {label: "Living with Parents", value: "parents"},
  {label: "Other", value: "others"},
]


export const relation_Status = [
  {label: "Spouse" , value:"Spouse"},
  {label: "Resides With" , value:"Resides With"},
  {label: "Parent" , value:"Parent"},
  {label: "Other" , value:"Other"},

]